import { createInteractiveColorVar } from '../../helpers/createInteractiveColorVar/index.js';

const ControlTextColors = createInteractiveColorVar('controls-text');
const ControlTextColorsLightValues = Object.freeze({
    default: '#525252',
    action: '#3D3D3D',
    active: '#000000',
    activeAction: '#3D3D3D',
});
const ControlTextColorsDarkValues = Object.freeze({
    default: '#B3B3B3',
    action: '#CCCCCC',
    active: '#FFFFFF',
    activeAction: '#CCCCCC',
});

export { ControlTextColors, ControlTextColorsDarkValues, ControlTextColorsLightValues };
